import {useSelector} from "react-redux";
import {Spinner} from "react-bootstrap";
import {useState} from "react";
import {selectLang} from "../../../../store/reducers/main/main";
import {Translate} from "../../../../lang/lang";
import {revisionDownloadPdfAsync} from "../../../../store/reducers/warehouse/revisionReducer";
import IconButton from "../../../../components/IconButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFilePdf} from "@fortawesome/free-solid-svg-icons";


const RevisionDownloadPdf = ({revisionId, number, ...props}) => {
    const [loading, setLoading] = useState(false)
    const lang = useSelector(selectLang)
    const t = Translate


    const downloadPdfRevision = () => {
        setLoading(true)
        revisionDownloadPdfAsync({revisionId})
            .then((response) => {
                const link = document.createElement("a");
                document.body.appendChild(link);

                const blobFile = new Blob([response], {type: 'application/pdf'});
                const blobUrl = window.URL.createObjectURL(blobFile);

                link.href = blobUrl;
                link.download = `${t(lang, "warehouse.item.download_excel.revision_name", {number: number})}.pdf`;
                link.click();
                link.remove();
                window.URL.revokeObjectURL(blobUrl);
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                setLoading(false)
            })
    }


    return (
        <>
            <IconButton {...props} icon={''} disabled={loading} size="sm"
                        className={'btn-davr bg-white text-dark d-flex gap-2'}
                        iconClassName={"text-primary-davr fs-8"} transform="shrink-3"
                        variant='phoenix-warning'
                        onClick={downloadPdfRevision}>
                {loading ? (
                        <Spinner className="align-middle ms-2" size="sm" animation="border" role="switch"/>
                    ) :
                    <FontAwesomeIcon className="me-1 fs-7 text-primary-davr" icon={faFilePdf}/>
                }
                <span
                    className="d-none d-sm-inline-block">{t(lang, "warehouse.operation.item.common.download_pdf")}</span>
            </IconButton>
        </>
    );
};

export default RevisionDownloadPdf;